import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'ORI',
    name: 'The Endless Decay',
    id: 'TheEndlessDecay',
    health: 70,
    difficulty: 5,
    expeditionRating: 3,
    additionalInfo: '',
    fightFiveAdditionalInfo: `
    <p>During setup, swap one of the nemesis turn order cards for the Unleash turn order card.</p>
    <p>SETUP: Put Atrophy into play from the Entropy deck.</p>
    `,
  },
]
